import { setSelectedRegionalDistricts } from 'shared/slices/geo';
import { TThunkAction } from 'shared/types/redux';
import { getGeoValueByType } from '../../../../packages/JsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { IJsonQueryRegionalDistrict } from 'packages/api-models/common/json_query';

export const syncRegionalDistricts = (): TThunkAction => (dispatch, getState) => {
  const state = getState();

  const jsonQuery = selectJsonQuery(state);
  const regionalDistricts = getGeoValueByType<IJsonQueryRegionalDistrict>('regional_district_id')(jsonQuery);

  dispatch(setSelectedRegionalDistricts(regionalDistricts || []));
};
